import { render } from "./CoreContainer.vue?vue&type=template&id=5132d4fa"
import script from "./CoreContainer.vue?vue&type=script&lang=js"
export * from "./CoreContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/champmar/Desktop/Outsource/seo-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__